export class DescriptiveError extends Error {
	constructor(message: string, private _errorCode: string) {
		super(message);
	}

	get code() {
		return this._errorCode;
	}
}
